import { authHeader, handleResponse } from '../helpers'

export const stageService = {
  getStages,
  getStage,
  createStage,
  updateStage,
  deleteStage,
  getStagesTemplate
}

function getStages(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/stages/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var stages = response.stages
      return stages
    })
}

function getStagesTemplate(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/stages/' + eventId + '/template',
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var stages = response.stages
      return stages
    })
}

function getStage(stageId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/stage/' + stageId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var stage = response
      return stage
    })
}

function createStage(stageData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: stageData
  }
  return fetch(process.env.VUE_APP_API_URL + '/stage', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var stage = response
      return stage
    })
}

function updateStage(stageId, stageData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: stageData
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/stage/' + stageId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var stage = response
      return stage
    })
}

function deleteStage(stageId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/stage/' + stageId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var stage = response
      return stage
    })
}
